import { styled } from "@linaria/react";
import React from "react";
import Link from "@components/_Revamp/Link";
import { Text } from "./Text";
import EmailIcon from "@assets/icon/email-Icon.svg";
import PhoneIcon from "@assets/icon/phone-Icon.svg";
import FaqIcon from "@assets/icon/faq-Icon.svg";
import VisitIcon from "@assets/icon/visit-Icon.svg";
import { css } from "@linaria/core";
import { SCREEN_SIZE } from "@static/screen-size";

const contactData = [
  {
    header: "Call",
    linkLabel: "+65 6827 9933",
    action: "tel:+65 6827 9933",
    description: "Mondays to Fridays:\n8:45am - 5:30pm",
    otherInfo: "(Closed on weekends and public holidays)",
    iconPath: PhoneIcon,
    underline: true,
  },
  {
    header: "Email",
    linkLabel: "cs_life@singlife.com",
    action: "mailto:cs_life@singlife.com",
    description:
      "Send us any enquiries or feedback. We'll get back to you as soon as possible.",
    iconPath: EmailIcon,
    underline: true,
  },
  {
    header: "FAQ",
    linkLabel: "Get answers",
    action: "https://singlife.com/en/faq",
    description: "to our most frequently asked questions.",
    target: "_blank",
    rel: "noopener noreferrer",
    iconPath: FaqIcon,
    underline: true,
  },
  {
    header: "Visit",
    linkLabel: `5 Straits View, #01-18/19, \n Marina One The Heart, \n Singapore 018935`,
    action:
      "https://maps.app.goo.gl/ZTkae2oTdTUtLXqV6",
    target: "_blank",
    rel: "noopener noreferrer",
    description: "Mondays to Fridays:\n8:45am - 5:30pm",
    otherInfo: "(Closed on weekends and public holidays)",
    iconPath: VisitIcon,
    underline: true,
  },
];

interface ContactusProps {
  color?: string;
  titleClass?: string;
  descriptionClass?: string;
  findoutLink?: {
    default: number;
    tablet: number;
  };
  cardInfoDescriptionClass?: string;
  cardInfoDescriptionSubClass?: string;
  cardInfoHeadingClass?: string;
  cardLinkClass?: {
    default: number;
    tablet: number;
  };
}

const Contactus: React.FC<ContactusProps> = ({
  color,
  children,
  descriptionClass,
  findoutLink,
  titleClass,
  cardInfoDescriptionClass,
  cardInfoDescriptionSubClass,
  cardInfoHeadingClass,
  cardLinkClass,
}) => {
  return (
    <>
      <DataTitleContainer>
        <hr
        className={hrStyle}
          style={{
            borderTop: "1px solid #D8D8D8",
            width: "100%",
          }}
        />
        <Text textClass={titleClass} variant="title">
          Need help?
        </Text>
        <Text
          textClass={descriptionClass}
          variant="description"
          color="#8A8988"
          margin="20px auto 0 auto"
        >
          To make a claim,{" "}
          <Link
            text="find out how"
            variant="link"
            url="https://singlife.com/en/make-a-claim/life-and-health"
            target="_blank"
            rel="noopener noreferrer"
            color={color || "#883E89"}
            fontSize={findoutLink?.default || 16}
            fontSizeTablet={findoutLink?.tablet || 16}
            underline={true}
          />
          .
        </Text>
        <Text
          textClass={`${textAligner} ${descriptionClass}`}
          variant="description"
          color="#8A8988"
          margin="0 auto 64px auto"
        >
          For other matters, get the support you need below.
        </Text>
      </DataTitleContainer>
      <DataCardContainer>
        {contactData.map((item: any) => (
          <DataCard
            key={item.header}
            header={item.header}
            description={item.description}
            otherInfo={item?.otherInfo}
            linkLabel={item.linkLabel}
            action={item.action}
            target={item?.target}
            iconPath={item.iconPath}
            underline={item?.underline}
            color={color}
            infoDescriptionClass={cardInfoDescriptionClass}
            infoDescriptionSubClass={cardInfoDescriptionSubClass}
            infoHeadingClass={cardInfoHeadingClass}
            linkClass={cardLinkClass}
          />
        ))}
      </DataCardContainer>
    </>
  );
};

export default Contactus;

const DataCard = ({
  linkLabel,
  action,
  header,
  description,
  otherInfo,
  target,
  iconPath,
  underline,
  color,
  infoHeadingClass,
  linkClass,
  infoDescriptionClass,
  infoDescriptionSubClass,
}: InfoContentProps & OtherContentProps) => {
  return (
    <InfoLayout>
      <div style={{ flex: 0 }}>
        <IconContainer color={color}>
          <img src={iconPath} alt="icon" />
        </IconContainer>
      </div>
      <InfoContentContainer rowGap="8px">
        <InfoHeading className={infoHeadingClass}>{header}</InfoHeading>
        <Link
          fontWeight={600}
          underline={underline || false}
          url={action}
          target={target}
          text={linkLabel}
          color={color}
          fontSize={linkClass?.default}
          fontSizeTablet={linkClass?.tablet}
        ></Link>
        <InfoDescription className={infoDescriptionClass}>
          {description}
        </InfoDescription>
        <InfoDescriptionSub className={infoDescriptionSubClass}>
          {otherInfo}
        </InfoDescriptionSub>
      </InfoContentContainer>
    </InfoLayout>
  );
};

const DataCardContainer = styled.div`
  max-width: 792px;
  margin: 0 auto;
  display: grid;
  //   gap: 1rem;
  column-gap: 40px;
  row-gap: 27px;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 64px;
  @media screen and (max-width: 768px) {
    margin: auto 24px;
    column-gap: 24px;
  }

  @media screen and (max-width: 588px) {
    grid-template-columns: 1fr;
    margin: auto 24px;
    justify-items: center;
    & > div {
      width: 100%;
      max-width: 327px;
    }
  }
`;

const textAligner = css`
  @media screen and (max-width: 588px) {
    text-align: center;
  }
`;

const IconContainer = styled.div<{ color?: string }>`
  background-color: ${(props) => (props.color ? props.color : "#883E89")};
  display: flex;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  img {
    height: 25px;
    width: 25px;
  }
  @media screen and (max-width: 588px) {
    width: 60px;
    height: 60px;
    img {
      height: 25px;
      width: 25px;
    }
  }
`;

const DataTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 792px;
  margin: 0 auto;
  p:nth-child(4){
    margin-bottom: 36px;

  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px){
    p:nth-child(4){
    margin-bottom: 48px;
  }
  }
`;

// Data card
const InfoLayout = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 24px;
  display: flex;
  column-gap: 8px;
  overflow-wrap: anywhere;
  max-width: 376px;
  height: max-content;
  min-height: 160px;
  @media screen and (min-width: 768px) {
    column-gap: 16px;
    overflow-wrap: unset;
  }
`;

const InfoDescriptionSub = styled.p`
  color: #434343;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
`;

const InfoDescription = styled.p`
  color: #444444;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  white-space: pre-line;
`;

const InfoHeading = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  color: #1e1e1e;
  @media screen and (min-width: 768px) {
    font-size: 20px;
  }
`;

const InfoContentContainer = styled.div<InfoContentProps>`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => (props.rowGap ? props.rowGap : "16px")};
  position: relative;
`;

export interface InfoBoxProps {
  children: JSX.Element;
  margin?: string | undefined;
  radius?: string;
}

export interface InfoContentProps {
  children?: React.ReactNode;
  rowGap?: string;
  infoHeadingClass?: string;
  linkClass?: {
    default: number;
    tablet: number;
  };
  infoDescriptionClass?: string;
  infoDescriptionSubClass?: string;
}

export interface OtherContentProps {
  linkLabel: string;
  action: string;
  header: string;
  description: string;
  otherInfo?: string;
  target?: string;
  iconPath: string;
  underline?: boolean;
  color?: string;
}

export interface InfoIconProps {
  width?: string;
  height?: string;
  rowGap?: string;
}

const hrStyle = css`
  margin : 36px auto;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin: 60px auto;
  } 
`